import React, { Component } from 'react';
import img from '../../../assets/Admin/TaxProfile_Content/19da825baec74cbfc40d97a580d2aa62_html_a6fb07e2582c1027.png';
import img1 from '../../../assets/Admin/TaxProfile_Content/19da825baec74cbfc40d97a580d2aa62_html_f10f20fa7f0b763b.png';
class TaxProfileContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Tax Profile:</b></p>
                <p>Tax Profile is maintained for different states with ranges. Tax profiles are added to system by uploading a file. Tax profile contains amount range tax percentage , Effective and termination date of tax profile.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img1} />
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
            </div>
        )
    }
}
export default TaxProfileContent;
